module.exports = __webpack_public_path__ + "media/Puzzle_Game_PowerUp_Light_02.db92f3f4.wav";